import { MatchInfoDto } from "sandy-shared/dist/dtos/match-info.dto";
import { PartnershipDto } from "sandy-shared/dist/dtos/partnership.dto";
import {StattedPointDto} from "sandy-shared/dist/dtos/statted-point.dto";

export const getMatchCurrentPlayerIds = (match: MatchInfoDto): number[] =>
    [match.homePartnership.playerOne.id, match.homePartnership.playerTwo.id, match.awayPartnership.playerOne.id, match.awayPartnership.playerTwo.id];

// Practice matches can have more than two partnerships in their history
export const getAllMatchPartnershipIds = (match: MatchInfoDto, pointHistory: StattedPointDto[]): number[] => {
  const matchPoints = pointHistory.filter(point => match.sets.find(set => set.id === point.setId));
  const partnershipIds = matchPoints.flatMap(point => [point.receivingPartnershipId, point.servingPartnershipId]);
  return Array.from(new Set(partnershipIds));
}

export const getPartnershipPlayerIds = (partnerships: PartnershipDto[]): number[] =>
  partnerships.flatMap(partnership => [partnership.playerOne.id, partnership.playerTwo.id]);

export const getAllMatchPlayerIds = (match: MatchInfoDto, pointHistory: StattedPointDto[], allPartnerships: PartnershipDto[]): number[] => {
  const matchPartnershipIds = getAllMatchPartnershipIds(match, pointHistory);
  const matchPartnerships = allPartnerships.filter(partnership => matchPartnershipIds.includes(partnership.id));
  return getPartnershipPlayerIds(matchPartnerships);
}
